"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var AnimatePaths = /** @class */ (function () {
    function AnimatePaths() {
        var _this = this;
        var _a, _b;
        this.options = {
            threshold: 0.2,
        };
        this.svgs = document.querySelectorAll("[".concat(constants_1.DATA_SVG_ANIMATE, "]"));
        (_a = this.svgs) === null || _a === void 0 ? void 0 : _a.forEach(function (svg) {
            var paths = svg === null || svg === void 0 ? void 0 : svg.querySelectorAll('path');
            paths === null || paths === void 0 ? void 0 : paths.forEach(function (path) { return path === null || path === void 0 ? void 0 : path.classList.add('draw'); });
        });
        var observer = new IntersectionObserver(function (entries) { return _this.callback(entries); }, this.options);
        (_b = this.svgs) === null || _b === void 0 ? void 0 : _b.forEach(function (svg) {
            observer.observe(svg);
        });
    }
    AnimatePaths.prototype.callback = function (entries) {
        var _this = this;
        entries === null || entries === void 0 ? void 0 : entries.forEach(function (entry) {
            var _a;
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) {
                (_a = _this.svgs) === null || _a === void 0 ? void 0 : _a.forEach(function (svg) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.target) === svg) {
                        var width = svg.viewBox.baseVal.width;
                        var renderWidth = svg.clientWidth;
                        var multiplier_1 = renderWidth / width;
                        var paths = svg === null || svg === void 0 ? void 0 : svg.querySelectorAll('.draw');
                        paths === null || paths === void 0 ? void 0 : paths.forEach(function (path) {
                            var pathLength = path === null || path === void 0 ? void 0 : path.getTotalLength();
                            if (multiplier_1 > 1) {
                                pathLength = multiplier_1 * pathLength;
                            }
                            path === null || path === void 0 ? void 0 : path.style.setProperty('--dasharray', pathLength === null || pathLength === void 0 ? void 0 : pathLength.toString());
                            path === null || path === void 0 ? void 0 : path.style.setProperty('--dashoffset', pathLength === null || pathLength === void 0 ? void 0 : pathLength.toString());
                            path === null || path === void 0 ? void 0 : path.classList.add('animate');
                        });
                    }
                });
            }
        });
    };
    return AnimatePaths;
}());
exports.default = AnimatePaths;
